import * as PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { selectIcon } from '../views/common/utils';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { useAdvancedSearch } from '../hooks/useAdvancedSearch';

export function FacetChoice(props) {
    const operatorOptions = (
        <div className="sui-advEditBool" title="Change boolean method">
            <div
                className={cx({
                    'sui-boolItem': true,
                    active: props.operator === 'AND',
                })}
                onClick={() => handleSetOperator('AND')}
                id="sui-boolItem-places-0-AND"
            >
                AND
            </div>
            |
            <div
                className={cx({
                    'sui-boolItem': true,
                    active: props.operator === 'OR',
                })}
                onClick={() => handleSetOperator('OR')}
                id="sui-boolItem-places-0-OR"
            >
                OR
            </div>
            |
            <div
                className={cx({
                    'sui-boolItem': true,
                    active: props.operator === 'NOT',
                })}
                onClick={() => handleSetOperator('NOT')}
                id="sui-boolItem-places-0-NOT"
            >
                NOT
            </div>
            &nbsp;
        </div>
    );

    const advSearchStore = useAdvancedSearch();

    function handleFacetAdd() {
        advSearchStore.facetAdded(props.value);
        props.onFacetClick({ ...props, action: 'add' });
    }

    function handleFacetRemove(x, y) {
        advSearchStore.facetRemoved(props.value);
        props.onFacetClick({ ...props, action: 'remove' });
    }

    function handleSetOperator(operator) {
        props.onFacetClick({
            ...props,
            operator: operator,
            action: 'changeOperator',
            mode: operator,
        });
    }

    const chosen = props.chosen ? 'chosen' : '';
    const icon = selectIcon(props.facetType);

    let label = props?.label;
    if (label === 'texts') {
        label = 'Modern Texts';
    }
    const choice =
        props.mode === 'add' ? (
            <div
                onClick={handleFacetAdd}
                className={'sui-advEditLine ' + chosen}
            >
                <span className={props.className}></span> {icon} {label}(
                {props.count}){' '}
            </div>
        ) : (
            <div>
                {props.booleanControls && operatorOptions}{' '}
                <span
                    onClick={handleFacetRemove}
                    className={props.className}
                ></span>{' '}
                {icon} {label}
            </div>
        );

    const renderTooltip = (p) => {
        return (
            <Popover {...p} className={'c-FacetChoice--popover'}>
                <Popover.Content>{props.value}</Popover.Content>
            </Popover>
        );
    };

    const wrapped_choice = (
        <OverlayTrigger
            placement="auto"
            delay={{ show: 150, hide: 200 }}
            overlay={renderTooltip}
            popperConfig={{
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 10],
                        },
                    },
                ],
            }}
        >
            {choice}
        </OverlayTrigger>
    );

    return wrapped_choice;
}

FacetChoice.propTypes = {
    className: PropTypes.string,
    value: PropTypes.any,
    count: PropTypes.any,
    mode: PropTypes.string,
    chosen: PropTypes.bool,
    onFacetClick: PropTypes.func,
};
